
import { graphql, type ResultOf, type VariablesOf } from '@client/shared/graphql';
import { gqlRequest } from '@client/shared/graphql';

export const ArchiveListingMutation = graphql(`
  mutation ArchiveListing($id: ID!) {
    archiveListing(id: $id) {
      id
      archivedAt
    }
  }
`);

export const UnarchiveListingMutation = graphql(`
  mutation UnarchiveListing($id: ID!) {
    unarchiveListing(id: $id) {
      __typename
      ... on Listing {
        id
        archivedAt
      }
      ... on ListingLimitReachedError {
        message
      }
    }
  }
`);

export type ArchiveListingVariables = VariablesOf<typeof ArchiveListingMutation>;
export type ArchiveListingResult = ResultOf<typeof ArchiveListingMutation>;

export type UnarchiveListingVariables = VariablesOf<typeof UnarchiveListingMutation>;
export type UnarchiveListingResult = ResultOf<typeof UnarchiveListingMutation>;

export type ArchivedListing = NonNullable<ArchiveListingResult['archiveListing']>;
export type UnarchivedListing = Extract<
  NonNullable<UnarchiveListingResult['unarchiveListing']>,
  { __typename: 'Listing' }
>;

export async function runArchiveListing(id: string): Promise<ArchivedListing> {
  const data = await gqlRequest(ArchiveListingMutation, { id });
  const listing = data.archiveListing;
  if (!listing) {
    throw new Error('The listing could not be archived. Please try again.');
  }
  return listing;
}

export async function runUnarchiveListing(id: string): Promise<UnarchivedListing> {
  const data = await gqlRequest(UnarchiveListingMutation, { id });
  const result = data.unarchiveListing;
  if (!result) {
    throw new Error('The listing could not be restored. Please try again.');
  }
  if (result.__typename !== 'Listing') throw new Error(result.message ?? 'Something went wrong. Please try again.');
  return result;
}
